import axiosInstance from "@/lib/axiosInterceptor";
import { queryOptions } from "@tanstack/react-query";
import { Result } from "types/result";
import { UsageDetail } from "../types/UsageDetail";

const getUsageDetail = async (): Promise<Result<UsageDetail>> => {
    try {
        const { data } = await axiosInstance.get<UsageDetail>(
            `${process.env.NEXT_PUBLIC_BE_URL}/daily-quota/usage-detail`,
        );
        return { data: { ...data, fetchedAt: new Date().getTime() }, error: null };
    } catch (e: any) {
        return { data: null, error: { message: e.message } };
    }
};

export const getUsageDetailOptions = () =>
    queryOptions({
        queryKey: ["daily-quota", "usage-details"],
        queryFn: getUsageDetail,
        staleTime: Infinity,
    });
